module.exports = __webpack_public_path__ + "img/b3.61a73bc0.png";